import * as React from 'react';
import './styles.css';
import { Infos } from '../../../@types/models/Infos';
const closeIcon = require('./close-Icon.svg');

export interface Props {
    infos: Infos;
    closeLightbox: (v: boolean) => void;
}

class Lightbox extends React.Component<Props> {
    constructor(props: Props) {
        super(props);
    }

    render() {
        const infos = this.props.infos;
        return (
            <div className="lightbox">
                <section className="lightbox__content">
                    <h2 className="lightbox__main-title">Information</h2>
                    {infos.InfosPanel && infos.InfosPanel.map((p, i) => {
                        return (
                            <div key={i}>
                                {p.Title && <h4 className="lightbox__title">{p.Title}</h4>}
                                {p.Text &&
                                    <div
                                        className="lightbox__text"
                                        dangerouslySetInnerHTML={{ __html: p.Text }}
                                    />
                                }
                            </div>
                        );
                    })}
                </section>
                <a
                    className="lightbox__close-btn"
                    onClick={() => this.props.closeLightbox(false)}
                >
                    <img src={closeIcon} alt="close lightbox icon" />
                </a>
            </div>);
    }
}

export default Lightbox;


// WEBPACK FOOTER //
// ./src/components/Lightbox/Component.tsx